import request from '@/utils/request'

/**
 * 公告管理
 */

// 获取公告列表
export const getNoticeList = (params: any) => {
  return request({
    url: '/admin/notice/page',
    method: 'get',
    params
  })
}

// 新增公告
export const addNotice = (params: any) => {
  return request({
    url: '/admin/notice',
    method: 'post',
    data: { ...params }
  })
}

// 修改公告
export const editNotice = (params: any) => {
  return request({
    url: '/admin/notice',
    method: 'put',
    data: { ...params }
  })
}

// 删除公告
export const deleteNotice = (ids: string) => {
  return request({
    url: `/admin/notice/${ids}`,
    method: 'delete'
  })
}

// 根据ID查询公告
export const queryNoticeById = (id: string | (string | null)[]) => {
  return request({
    url: `/admin/notice/${id}`,
    method: 'get'
  })
}

// 查看公告（增加浏览次数）
export const viewNotice = (id: string) => {
  return request({
    url: `/user/notice/${id}`,
    method: 'get'
  })
}

// 更新公告状态
export const updateNoticeStatus = (id: string, status: string) => {
  return request({
    url: `/admin/notice/status/${status}`,
    method: 'put',
    params: { id }
  })
}

// 增加浏览次数
export const increaseViewCount = (id: string) => {
  return request({
    url: `/user/notice/view/${id}`,
    method: 'put'
  })
}

// 设置公告状态
export const setNoticeStatusByStatus = (id: string, status: string) => {
  return request({
    url: `/admin/notice/status/${status}`,
    method: 'put',
    params: { id }
  })
} 